import { connectToCardinalNumeralFactory } from './utils'

// TODO переделать согласование причастий
/**
 * Объект, хранящий правила множественных чисел для разных слов
 *
 * Разные части речи по разному согласуются с числительными
 *
 * Например, слова с категорией падежа и рода:
 *
 * Минута (категория падежа):
 * - Именительный падеж (кто? что?) : 1 минута
 * - Винительный  падеж (кого? что?): 1 минуту
 *
 * Добавлено (категория рода):
 * - мужской род: добавлен 1 маркер
 * - женский род: добавлена 1 скважина
 *
 * Соответственно, все возможные формы используемых слов
 * должны быть описаны отдельно
 *
 * **Ключ этого словаря должен соответствовать форме слова
 * в требуемом падеже/роде для единственного числа**
 */
export const availableWords = {
  // Винительный падеж
  минуту: connectToCardinalNumeralFactory({
    zero: 'минут',
    one: 'минуту',
    two: 'минуты',
    few: 'минуты',
    many: 'минут',
    other: 'минуты',
  }),
  // Именительный падеж
  минута: connectToCardinalNumeralFactory({
    zero: 'минут',
    one: 'минута',
    two: 'минуты',
    few: 'минуты',
    many: 'минут',
    other: 'минуты',
  }),
  маркер: connectToCardinalNumeralFactory({
    zero: 'маркеров',
    one: 'маркер',
    two: 'маркера',
    few: 'маркера',
    many: 'маркеров',
    other: 'маркера',
  }),
  // Средний род
  добавлено: connectToCardinalNumeralFactory({
    zero: 'добавлено',
    one: 'добавлен',
    two: 'добавлено',
    few: 'добавлено',
    many: 'добавлено',
    other: 'добавлено',
  }),
  // Средний род
  обновлено: connectToCardinalNumeralFactory({
    zero: 'обновлено',
    one: 'обновлен',
    two: 'обновлено',
    few: 'обновлено',
    many: 'обновлено',
    other: 'обновлено',
  }),
  // Средний род
  пропущено: connectToCardinalNumeralFactory({
    zero: 'пропущено',
    one: 'пропущен',
    two: 'пропущено',
    few: 'пропущено',
    many: 'пропущено',
    other: 'пропущено',
  }),
  // Именительный падеж
  ошибка: connectToCardinalNumeralFactory({
    zero: 'ошибок',
    one: 'ошибка',
    two: 'ошибки',
    few: 'ошибки',
    many: 'ошибок',
    other: 'ошибки',
  }),
  // Именительный падеж
  проблема: connectToCardinalNumeralFactory({
    zero: 'проблем',
    one: 'проблема',
    two: 'проблемы',
    few: 'проблемы',
    many: 'проблем',
    other: 'проблемы',
  }),
}
